import React from 'react'
import Grid from '@material-ui/core/Grid'
import {makeStyles} from '@material-ui/core/styles'
// import Suha from './dev_suha_icon.png'
import Suha from '../../assets/chatbot_bubble.png'

const useStyles = makeStyles((theme) => ({
    contentContainer: {
        backgroundColor: theme.palette.primary.light,
    },
    avatar: {
        margin: theme.spacing(1),
    },
}))

function SuhaAvatarImage() {
    const classes = useStyles()
    return (
        <React.Fragment>
            <img className={classes.avatar} src={Suha} alt="Suha mascot avatar"/>
        </React.Fragment>
    )
}

interface SuhaAvatarProps {
    position?: number
}

export default function SuhaBubble(props: SuhaAvatarProps) {
    let position = props.position || 0

    // @ts-ignore
    return (
        <React.Fragment>
            <Grid
                item
                xs={12}
                container
                alignItems="center"
                style={{justifyContent:"center"}}
            >
                <Grid item alignItems={'center'} justifyContent={'center'} style={{display: "flex"}}>
                    <SuhaAvatarImage/>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
